export default {"src":"/_next/static/media/ins.61d13341.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};